import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from "account-hybrid/core/authentication";
import { Observable, throwError } from 'rxjs';
import { catchError } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {


    constructor(private sessionService: SessionService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.indexOf('/api') > -1 && !req.url.includes('googleapis')) {
            return next.handle(
                req.clone({ withCredentials: true })
            ).pipe(catchError(err => {
                if (err.status === 403 || err.status === 401) {
                    this.sessionService.signOut();
                }
                return throwError(err);
            }));
        } else {
            return next.handle(req);
        }
    }
}
